// extracted by mini-css-extract-plugin
export default {"tableContainer":"ShipmentList_tableContainer__EQAVD","table":"ShipmentList_table__hmIFy","popover":"ShipmentList_popover__vicp6"};